import { similarityFeatureDisplay } from "./similarSeasonsFeatureGlossary";

export function nflSimilarityStatLabel(metric, fallback) {
  return similarityFeatureDisplay(metric, fallback).label;
}

export function formatNflSimilarityStat(metric, value) {
  return similarityFeatureDisplay(metric).format(value);
}

export function nflTeamLabel(teamId) {
  return teamId || null;
}

export function nflTeamLogoId() {
  return null;
}

export const NFL_SIMILAR_SEASON_DISPLAY = {
  statLabel: nflSimilarityStatLabel,
  formatStat: formatNflSimilarityStat,
  teamLabel: nflTeamLabel,
  teamLogoId: nflTeamLogoId,
  ineligibleMessage:
    "This season is not in the similarity index. Seasons below the playing-time threshold (150 pass attempts, 80 rush attempts, or 40 receptions) or missing required stats are excluded.",
};
